import { IMenuItemModel } from "@/models";
import { Box, Collapse } from "@mui/material";
import clsx from "clsx";
import Link from "next/link";

const SidebarCollapse = ({
  item,
  isShowFullMenu,
}: {
  item: IMenuItemModel;
  isShowFullMenu: boolean;
}) => {
  return (
    <>
      {item.children && item.children.length > 0 ? (
        <>
          {isShowFullMenu && (
            <Collapse
              collapsedSize={"0px"}
              in={item.isCollapse}
              sx={{
                maxWidth: "100%",
                width: "100%",
                opacity: `${item.isCollapse ? "1" : "0"}`,
                transition: "all .5s",
              }}
              timeout={500}
            >
              <Box
                component={"ul"}
                className="p-0 list-none m-0 h-full flex-auto"
              >
                {item.children.map((itemChild, indexChild) => {
                  return (
                    <Box
                      component={"li"}
                      key={indexChild}
                      className="text-disabled-text"
                    >
                      <Link
                        href={itemChild.url}
                        className={clsx(
                          "flex items-center w-full gap-2 px-5 pl-7 py-3  pr-[52px] text-white hover:text-white text-ellipsis overflow-hidden text-nowrap",
                          itemChild.isActive && "text-white",
                        )}
                      >
                        - {itemChild.name}
                      </Link>
                    </Box>
                  );
                })}
              </Box>
            </Collapse>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default SidebarCollapse;
